export default "__VITE_ASSET__CG4n4gbU__"